import { fetchCollectionApi } from 'common/api';
import { put } from 'redux-saga/effects';
import { addCarouselInStore } from 'pages/home.page/video-carousel/actions';
import { errorHandleAction } from 'components/error-handle/actions';
import { fetchSortedVideosApi } from 'common/api/videos';

const sortingKeys = {
  newest: 'displayDate',
  mostPlayed: 'plays',
  topRated: 'rating',
};

/**
 * @param {object} action
 */
export function* addCarouselEffect(action) {
  try {
    let response;
    yield put(
      addCarouselInStore(
        action.payload.channelId,
        action.payload.pageNum,
        action.payload.perPage,
        action.payload.position,
        [],
        0,
        true
      )
    );
    if (isNaN(action.payload.channelId)) {
      response = yield fetchSortedVideosApi(
        action.payload.pageNum,
        action.payload.perPage,
        // default to "displayDate" if requested sorting isn't implemented
        sortingKeys[action.payload.channelId] || 'displayDate',
        'desc'
      );
    } else {
      response = yield fetchCollectionApi({
        channelId: action.payload.channelId,
        pageNum: action.payload.pageNum,
        perPage: action.payload.perPage,
        featuredFirst: false,
      });
    }

    yield put(
      addCarouselInStore(
        action.payload.channelId,
        action.payload.pageNum,
        action.payload.perPage,
        action.payload.position,
        response.videos,
        response.totalCount,
        false
      )
    );
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
